import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// import * as signalR from '@microsoft/signalr';
import { Inquerito } from './inquerito.model';

@Injectable({
  providedIn: 'root'
})
export class InqueritoService {

  urlmdc: string = environment.apiBaseURL + '/inquerito/mdc';
  urlValidateData: string = environment.apiBaseURL + '/inquerito/validar-data';
  urlInquiryHub: string = environment.apiBaseURL + '/inquiryHub';
  //private hubConnection!: signalR.HubConnection;
  public endDate = new BehaviorSubject<Date | null>(null);

  constructor(private http: HttpClient) {
    // this.startConnection();
    // this.addInquiryEndDateListener();
  }

  getValidateData() {
    return this.http.get<boolean>(this.urlValidateData);
  }

  getInquiryMdC() {
    return this.http.get<Inquerito>(this.urlmdc);
  }

  /*
  private startConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder().withUrl(this.urlInquiryHub).build();
    this.hubConnection
      .start()
      .then(() => console.log('SignalR connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }

  private addInquiryEndDateListener() {
    this.hubConnection.on('InquiryEndDateUpdated', (newEndDate: Date) => {
      this.endDate.next(new Date(newEndDate));
    });
  }
  */
}
